import { createApp } from 'vue';
import { createI18n } from 'vue-i18n/index';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import Toaster from '@meforma/vue-toaster';

// import setupI18n from './i18n.js';

// const i18n = setupI18n();

import de from './locales/de.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import pt from './locales/pt.json';
import ru from './locales/ru.json';
import tr from './locales/tr.json';
import zh from './locales/zh.json';
import uk from './locales/uk.json';
axios.defaults.baseURL = '/api/';

const i18n = createI18n({
  locale: 'en',
  messages: {
    de,
    en,
    es,
    fr,
    it,
    pt,
    ru,
    tr,
    zh,
    uk
  }
  // fallbackLocale: 'ru'
});

axios.interceptors.response.use(undefined, error => {
  if (error) {
    console.log({error})
    const originalRequest = error.config;
    if (error.response.status === 403 && error.response.data.from === 'dashboard') {
      store.dispatch('logoutAdmin');
      return router.push('dashboard/login');
    }
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      store.dispatch('logout');
      return router.push('login');
    }
  }
});

const authToken = localStorage.authToken;
if (authToken) {
  axios.defaults.headers.common['Authorization'] = authToken;
}

const adminAuthToken = localStorage.adminAuthToken;
if (authToken) {
  axios.defaults.headers.common['Authorization'] = 'Bearer '+adminAuthToken;
}

const app = createApp(App).use(router);
app.use(Toaster);
app.use(VueVirtualScroller);
app.use(i18n);
app.use(store);
app.config.globalProperties.axios = axios;
app.mount('#app');
